import s from "./isArrayLike.js";
function h(t, a) {
  return function(r, u) {
    if (r == null)
      return r;
    if (!s(r))
      return t(r, u);
    for (var f = r.length, e = a ? f : -1, n = Object(r); (a ? e-- : ++e < f) && u(n[e], e, n) !== !1; )
      ;
    return r;
  };
}
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_createBaseEach.js
// module id = 1505
// module chunks = 67